@if (data.icon) {
  <mat-icon class="snack-bar-icon">{{ data.icon }}</mat-icon>
}
<span class="snack-bar-message">{{
  data.messageKey | translate: data.params
}}</span>
@if (data.actions?.length) {
  <span class="snack-bar-actions">
    @for (action of data.actions; track action.label) {
      <span class="snack-bar-action-btn" (click)="handleAction(action)">
        {{ action.label | translate }}
      </span>
    }
  </span>
}
